import { Action } from 'typescript-fsa'

type ActionHandler<T, V> = {
  [key: string]: (state: T, payload: V) => T
}

export class ReducerBuilder<T, V> {
  initialState: T
  actions: ActionHandler<T, V> = {}

  constructor(initialState: T) {
    this.initialState = initialState
    return this
  }

  mapAction(type: string, fn: (state: T, payload: V) => T): this {
    this.actions[type] = fn
    return this
  }

  build(): (state: T, action: Action<V>) => T {
    return (state: T = this.initialState, action: Action<V>) => {
      for (const type in this.actions) {
        if (action.type === type) {
          return this.actions[type](state, action.payload)
        }
      }
      return state
    }
  }

  static create<T, V>(initialState: T) {
    return new ReducerBuilder<T, V>(initialState)
  }
}
